import { render, staticRenderFns } from "./EInvoiceSubmissionsSection.vue?vue&type=template&id=9db9a980"
import script from "./EInvoiceSubmissionsSection.vue?vue&type=script&lang=js"
export * from "./EInvoiceSubmissionsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports